import { Navigate, useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useFeatureToggleState } from 'app/hooks/useFeatureToggle'
import { IvrBuilderComponent } from 'app/components/ivr-builder/IvrBuilderComponent'
import { useIvrBuilder } from 'app/components/ivr-builder/useIvrBuilder'

// observer: reads the dni feature toggle in render; useFeatureToggleState resolves false -> real
// asynchronously and its contract requires an observer wrapper (TRK-6020).
const IvrPage = observer(function IvrPage() {
  const { locationId } = useParams()
  const dni = useFeatureToggleState(`dni`)

  if (!dni.settled) return null
  if (!dni.enabled) return <Navigate to={`/settings/location-settings/${locationId}/general`} replace />
  return <IvrBuilderInner />
})

export default IvrPage

function IvrBuilderInner() {
  const props = useIvrBuilder()
  return <IvrBuilderComponent {...props} />
}
